import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../features/blogs/blogsSlice";
import Loading from "../ui/Loading";
import BlogItem from "./BlogItem";

const BlogList = () => {
    const dispatch = useDispatch();

    const { blogs, isLoading, isError, error } = useSelector(
        (state) => state.blogs
    );

    const { sort, filter } = useSelector((state) => state.filter);

    useEffect(() => {
        dispatch(fetchBlogs({ sort, filter }));
    }, [dispatch, sort, filter]);

    const sortedBlogs = (a, b) => {
        if (sort === "most_liked") {
            return b.likes - a.likes;
        }
        return;
    };

    // decide what to render
    let content;

    if (isLoading) content = <Loading />;
    if (!isLoading && isError)
        content = <div className="col-span-12">{error}</div>;

    if (!isError && !isLoading && blogs?.length === 0) {
        content = <div className="col-span-12">No blogs found!</div>;
    }

    if (!isError && !isLoading && blogs?.length > 0) {
        content = blogs
            .slice()
            .sort(sortedBlogs)
            .map((blog) => <BlogItem key={blog.id} blog={blog} />);
    }

    return (
        <main className="post-container" id="lws-postContainer">
            {content}
        </main>
    );
};

export default BlogList;
